import { createContext, useContext } from "react";

export type PageId =
  | "landing"
  | "dashboard"
  | "nouvelle"
  | "fiches"
  | "fiche"
  | "pricing"
  | "brand"
  | "settings"
  | "legal";

/** Tabs disponibles sur la page Settings — string brut pour éviter d'importer
 *  un type local de Settings.tsx (et créer un cycle). Settings.tsx caste vers
 *  son propre TabId avec un fallback safe. */
export type SettingsTab =
  | "profil"
  | "branding"
  | "equipe"
  | "abonnement"
  | "donnees"
  | "preferences";

export type NavOpts = {
  /** Currently-viewed fiche, when page === "fiche". null → show demo fiche. */
  ficheId?: string;
  /** Tab cible quand page === "settings". Lu une fois au mount par Settings,
   *  puis l'user peut cliquer librement dans les tabs. */
  settingsTab?: SettingsTab;
};

export type NavContextValue = {
  page: PageId;
  ficheId: string | null;
  /** Tab pré-sélectionnée pour Settings (consommée à chaque navigation
   *  vers settings). null = laisser Settings choisir son défaut. */
  settingsTab: SettingsTab | null;
  go: (page: PageId, opts?: NavOpts) => void;
};

export const NavContext = createContext<NavContextValue>({
  page: "landing",
  ficheId: null,
  settingsTab: null,
  go: () => {},
});

export function useNav() {
  return useContext(NavContext);
}
